/**
 * Display helpers for product specification values stored as "true"/"false".
 * Storage and submit stay as true/false strings; only UI labels change.
 */

const TRUE_TOKENS = new Set(['true', 'yes', 'ja', 'oui']);
const FALSE_TOKENS = new Set(['false', 'no', 'nee', 'non']);

export function isBooleanSpecValue(value: string | null | undefined): boolean {
    const raw = String(value ?? '').trim().toLowerCase();
    if (!raw) return false;
    return TRUE_TOKENS.has(raw) || FALSE_TOKENS.has(raw);
}

/**
 * Map boolean-like stored values to Yes/No for end users.
 * Non-boolean values are returned unchanged.
 */
export function formatSpecDisplayValue(
    value: string | null | undefined,
    tr?: (key: string, fallback: string) => string
): string {
    const raw = String(value ?? '').trim();
    if (!raw) return '';

    const lower = raw.toLowerCase();
    if (TRUE_TOKENS.has(lower)) {
        return tr ? tr('common.yes', 'Yes') : 'Yes';
    }
    if (FALSE_TOKENS.has(lower)) {
        return tr ? tr('common.no', 'No') : 'No';
    }
    return raw;
}
